module.exports = {
  animation: require('./animation'),
  keyframes: require('./keyframes')
};
